<template>
	<div class="quesstion">
        <div class="title"><span style="color:red">*</span>{{sortNum}}、{{questionData.question}}<span style="color:#ccc">{{questionData.tip}}</span></div>
        <div class="score">
            <!-- <div class="answer d-flex">
                <div class="tips"></div>
                <div class="schild d-flex">
                    <span>1</span>
                    <span>2</span>
                    <span>3</span>
                    <span>4</span>
                    <span>5</span>
                    <span>6</span>
                    <span>7</span>
                    <span>8</span>
                    <span>9</span>
                    <span>10</span>
                </div>
            </div> -->
            <div class="answer d-flex" v-for="(item,index) in questionData.options" :key="index">
                <div class="">{{item}}</div>
                <scoreGroup :name="item" :optionNum="index" :isReset="isReset" @getchildScore="getchildScore"></scoreGroup>
            </div>
        </div>
	</div>
</template>
<script>
import scoreGroup from './scoreGroup';
export default {
    name: "score",
    components:{scoreGroup},
    props: {
		questionData:{
			type:Object,
			default:{}
        },
        sortNum:{
            type:Number,
            default:0
        },
        isReset:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        questionData:{
            handler(newVal,oldVal){
                for(let item of this.questionData.options){
                    let val={
                        score:null,
                        answer:item
                    }
                    this.childLidt.push(val)
                }
            },
            deep:true,
            immediate:true
        },
        isReset:{
            handler(newVal,oldVal){
                if(newVal){
                    this.childLidt = [];
                    for(let item of this.questionData.options){
                        let val={
                            score:null,
                            answer:item
                        }
                        this.childLidt.push(val)
                    }
                }
            },
            immediate:true
        }
    },
    data() {
        return {
            childLidt:[]
        }
    },
    mounted() {
        
    },
    methods: {
        getchildScore(res){
            for(let index_ in this.childLidt){
                if(Number(index_) == res.sortIndex){
                    this.childLidt[index_].score = res.score;
                }
            }
            for(let item of this.childLidt){
                if(item.score===null){
                    return false;
                }
            }
            let parms = {
                    id:this.questionData.id,
                    questionnaireIssuesId:this.questionData.questionnaireIssuesId,
                    options:this.childLidt
                }
            this.$emit('getScoredata',parms)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionScore.vue